import type { BulkPurchaseState } from '../interfaces/BulkPurchase.model';

export const bulkPurchaseInitialState: BulkPurchaseState = {
  data: [],
};
